import ArrowLeft from '../src/ArrowLeft';
export default ArrowLeft;
